import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lms-data-table-search"},[(_vm.active)?_c('div',{staticClass:"input"},[_c(VTextField,{ref:"textField",attrs:{"append-icon":"mdi-close","outlined":"","name":"search","label":_vm.$t('labels.search'),"hide-details":""},on:{"click:append":_vm.toggle},model:{value:(_vm.term),callback:function ($$v) {_vm.term=$$v},expression:"term"}})],1):_c('div',[_c('div',{staticClass:"open",on:{"click":_vm.toggle}},[_c(VIcon,[_vm._v("mdi-magnify")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }